<template>
  <HeraConfirm
    :cancel-button-text="false"
    :confirm-button-text="$t('_web_leave-confirm-ok', 'OK')"
    class="rules-modal"
    @confirm="confirmLeave"
    @cancel="confirmLeave"
  >
    <div class="d-flex align-items-center justify-content-between mb-4">
      <Subheader
        :text="$t('_web_tournaments_info_attachment-btn', 'Format & Rules')"
        class="mb-0"
      />
      <HeraFormBtn
        v-if="rulesLink"
        icon="attach"
        icon-size="16"
        class="has-attach-icon d-flex align-items-center justify-content-around competition-info-wrapper__attachment mx-0"
      >
        <a class="text-white mx-1" :href="rulesLink" target="_blank">{{
          $t('_web_tournaments_rules_attachment-btn', 'Attachment')
        }}</a>
      </HeraFormBtn>
    </div>
    <TextContent v-if="rulesText" :content="rulesText" class="text-left" />
    <Dummy
      v-else
      class="rules-modal-emptystate"
      icon-name="dummy/newsfeed"
      :size="210"
      :text="
        $t(
          '_web_tournaments_rules_text-not-specified',
          'Rules text not provided'
        )
      "
    />
  </HeraConfirm>
</template>

<script>
import HeraConfirm from './HeraConfirm';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import Subheader from '@/components/atoms/Subheader';
import TextContent from '@/components/text/TextContent';
import Dummy from '@/components/common/HeraDummyList';
import { mapActions } from 'vuex';
import { prop } from '@/utils/factories';
export default {
  name: 'HeraConfirmLeave',
  components: { HeraConfirm, HeraFormBtn, Subheader, TextContent, Dummy },

  props: {
    rulesText: prop(String),
    rulesLink: prop(String),
  },

  methods: {
    ...mapActions(['closeModal']),
    confirmLeave() {
      this.closeModal(false);
    },
  },
};
</script>
<style lang="scss">
.confirm.rules-modal {
  width: 90vw;
  max-width: 720px;
}
.rules-modal-emptystate {
  min-height: 240px !important;
}
</style>
